//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import ChartSingleCoin from '~/components/landing/chart_single_coin'
import ChartSingleCoinMobile from '~/components/landing/chart_single_coin_mobile'

export default {
  name: 'NewPopular',
  components: { ChartSingleCoin, ChartSingleCoinMobile },
  data () {
    return {
      digitalPrices: null
    }
  },
  computed: {
    ...mapGetters({
      trends: 'coins/trends',
      latest: 'coins/latest',
      gainer: 'coins/gainer'
    })
  },
  created () {
    this.getPrice()
  },
  methods: {
    getPrice () {
      this.$store.dispatch('axios/get', { url: '/application/pwInfo/TOMAN', config: { baseURL: process.env.BASE_URL_UUID } })
        .then((resp) => {
          this.digitalPrices = resp.data.data
        })
    }
  }
}
